import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    sidebarCollapse: true,
});

export const SidebarContext = ctx;

export const SidebarProvider = Provider;
